import { fetchConToken } from "../../helpers/fetch";
import { handleErrorApi } from "../../helpers/randoms";
import { types } from "../../types/types";
import { startAlerta } from "../ui/alertas";
import { finishSpinner, startSpinner } from "../ui/spinner";

export const getLiquidadores = () => 
    async (dispatch) => {
        dispatch(startSpinner());
        dispatch({ type: types.efectoresPorLiquidadorTraerStart })
        try {
            const response = await fetchConToken(`EfectoresPorLiquidador`)
            const body = await response.json();
            if (response.ok) {
                dispatch({
                    type: types.efectoresPorLiquidadorTraerSuccess,
                    payload: body,
                });
                dispatch(finishSpinner());
            } else {
                throw body;
            }
        } catch (error) {
            dispatch(finishSpinner())
            dispatch({ type: types.efectoresPorLiquidadorTraerError })
            handleErrorApi(
                dispatch,
                error,
                "Error al traer los liquidadores",
                "Ha ocurrido un error. Intente nuevamente"
            );
    }
}

export const postLiquidador = (data, handleClose) => 
    async (dispatch) => {
    try {
      dispatch(startSpinner());
      const result = await fetchConToken('EfectoresPorLiquidador', data, "POST");
      const body = await result.json();
      if (result.ok) {
        dispatch({
            type: types.efectoresPorLiquidadorInsert,
            payload: body,
        });
        dispatch(startAlerta(`Liquidador Guardado`,'success','Comando Exitoso'));
        handleClose(false);
        dispatch(finishSpinner());
      } else {
        throw body
      }
    } catch (error) {
        dispatch(finishSpinner());
        handleErrorApi(
            dispatch,
            error,
            "Error al guardar liquidador",
            "Ha ocurrido un error. Intente nuevamente"
        );
    }
}

export const updateLiquidador = (data, handleClose) => 
    async (dispatch) => {
    try {
      dispatch(startSpinner());
      const result = await fetchConToken(`EfectoresPorLiquidador/${data.idLiquidador}`, data, "PUT");
      const body = await result.json();
      if (result.ok) {
        dispatch(getLiquidadores());
        dispatch(startAlerta(`Liquidador Modificado`,'success','Comando Exitoso'));
        handleClose(false);
        dispatch(finishSpinner());
      } else {
        throw body
      }
    } catch (error) {
        dispatch(finishSpinner());
        handleErrorApi(
          dispatch,
          error,
          "Error al modificar liquidador",
          "Ha ocurrido un error. Intente nuevamente"
        );
    }
}

export const deleteLiquidador = (idLiquidador) => {
    return async (dispatch) => {
      try{
        dispatch(startSpinner());
        const result = await fetchConToken(`EfectoresPorLiquidador/${idLiquidador}`, {}, "DELETE");
        const body = await result.json();
        if (result.ok) {
            dispatch({
            type: types.efectoresPorLiquidadorDelete,
            payload: idLiquidador
            }); 
            dispatch(startAlerta(`Liquidador Eliminado`,'success','Comando Exitoso'));
            dispatch(finishSpinner());
        } else {
            throw body
        }
      } catch (error) {
        dispatch(finishSpinner());
        handleErrorApi(
            dispatch,
            error,
            "Error al eliminar liquidador",
            "Ha ocurrido un error. Intente nuevamente"
        );
      }
    }
  }

  export const getEfectoresPorLiquidadorPorUsuario = (idLiquidador) => 
    async (dispatch) => {
        dispatch(startSpinner());
        dispatch({ type: types.efectoresPorLiquidadorTraerStart })
        try {
            const response = await fetchConToken(`EfectoresPorLiquidador/PorUsuario/${idLiquidador}`)
            const body = await response.json();
            if (response.ok) {
                dispatch({
                    type: types.efectoresPorLiquidadorPorUsuarioTraerSuccess,
                    payload: body,
                });
                dispatch(finishSpinner());
            } else {
                throw body;
            }
        } catch (error) {
            dispatch(finishSpinner())
            dispatch({ type: types.efectoresPorLiquidadorTraerError })
            handleErrorApi(
                dispatch,
                error,
                "Error al traer los efectores por liquidadores",
                "Ha ocurrido un error. Intente nuevamente"
            );
    }
}